export const TjenesteTyper = {
  teori: "teori",
  tungTeori: "tung-teori",
  forerkort: "førerkort",
  registrering: "registrering",
  fartsskriver: "fartsskriver", 
} as const;